var _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 17.7998H37.4444C38.3036 17.7998 39 18.4639 39 19.2831V34.1165C39 34.9357 38.3036 35.5998 37.4444 35.5998H12.5556C11.6964 35.5998 11 34.9357 11 34.1165V19.2831C11 18.4639 11.6964 17.7998 12.5556 17.7998H13.8",
    stroke: "#F1BF70",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32.5,
    width: 2,
    height: 2.1,
    fill: "#F1BF70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15.7C14 15.7 16.75 15 19.5 15C22.25 15 25 15.7 25 15.7V32.5C25 32.5 22.25 31.8 19.5 31.8C16.75 31.8 14 32.5 14 32.5V15.7Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 15.7C25 15.7 27.75 15 30.5 15C33.25 15 36 15.7 36 15.7V32.5C36 32.5 33.25 31.8 30.5 31.8C27.75 31.8 25 32.5 25 32.5V15.7Z",
    stroke: "#F1BF70",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2001 17.0996V30.3996H34.6332H32.5037H31.4709C29.8582 30.3996 29.0041 28.5649 30.0776 27.4069L33.4691 23.7495L30.0776 20.0923C29.0041 18.9344 29.8582 17.0996 31.4709 17.0996H32.5037H34.6332H35.2001Z",
    fill: "#F9E5C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.7002V22.0002L19.25 19.8402L21.5 22.0002V15.7002H17Z",
    fill: "#F1BF70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavo);
export default __webpack_public_path__ + "static/media/favo.be08ef5cae30c6f144e4c23024daa769.svg";
export { ForwardRef as ReactComponent };